






















































































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import ProductList from '@/store/entities/front-distributionproduct'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import appconst from '@/lib/appconst';
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
    class ProductListRequest extends PageRequest {
        createTime?: Date;
        endTime?: Date;
        name: string;
        skuCode: string;
        productId: string;
        warehouseId?: number;
    }

    @Component({
        name: "frontdistributionproduct",
    })

    export default class Orders extends AbpBase {
        pagerequest: ProductListRequest = new ProductListRequest();
        model: Array<ProductList> = new Array<ProductList>();
        spinShow: boolean = false;
        userpage: number = 1;
        createTime: Date[] = [];
        storeaddressList: Array<storeaddressInfo> = [];
        jumpage(data: any) {
           // var url = "http://localhost:1337/#/" + "shopdetailDisplay/goodsdetail?id=" + data.productId;
            var url = "https://warehouse.qianchanchan.com/#/" + "shopdetailDisplay/goodsdetail?id=" + data.productId;
            window.open(url);
        }

        get list() {
            return this.$store.state.frontdistributionproduct.list;
        };
        get loading() {
            return this.$store.state.frontdistributionproduct.loading;
        }
        get pageSizeOpts() {
            return this.$store.state.frontdistributionproduct.pageSizeOpts;
        }
        pageChange(page: number) {
            this.$store.commit('frontdistributionproduct/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontdistributionproduct/setPageSize', pagesize);
            this.getpage();
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true }); 
            this.storeaddressList.push(a);
            //if (this.storeaddressList.length > 0) {
            //    this.pagerequest.warehouseId = this.storeaddressList[0].id;
            //}
        }
        async getpage() {
            this.spinShow = true;
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (this.createTime.length > 0) {
                this.pagerequest.createTime = this.createTime[0];
            }
            if (this.createTime.length > 1) {
                this.pagerequest.endTime = this.createTime[1];
            }
            await this.$store.dispatch({
                type: 'frontdistributionproduct/getAll',
                data: this.pagerequest
            }).finally(() => {
                this.spinShow = false;
            });
            this.model = this.$store.state.frontdistributionproduct.list;
        }
      
        async searchPage() {
            this.$store.state.frontdistributionproduct.currentPage = 1;
            this.getpage();

        }
        get pageSize() {
            return this.$store.state.frontdistributionproduct.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontdistributionproduct.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontdistributionproduct.currentPage;
        }
        async created() {
            await this.getData();
            this.getpage();
        
        }
        async mounted() {

        }
    }
